@if (vehicle()) {
  <div
    [ngClass]="[
      'h-full w-full max-lg:hidden md:w-[290px] 2xl:w-[390px] 3xl:w-[490px]',
      'relative max-w-full overflow-hidden',
      'border-l border-stone-200',
      '',
    ]"
    class="bg-zinc-50"
    data-testid="vehicle-details-sidebar">
    <div class="absolute inset-0 overflow-y-auto px-4 pt-4 text-center text-xs 3xl:px-16 3xl:pt-16 3xl:text-left">
      <div class="inline-block max-w-full overflow-hidden p-2 text-left lg:p-4">
        <div class="overflow-hidden rounded-lg border bg-white p-2 text-center">
          @if (vehicleImageUrl()) {
            <img
              [alt]="vehicleImageUrl()?.alt || ''"
              [ngSrc]="vehicleImageUrl()?.url || ''"
              class="h-[220px] w-[299px] object-contain"
              width="299"
              height="220"
              priority
              onerror="this.src='assets/images/vehicle_fallback.png';this.classList.add('opacity-30')" />
          } @else {
            <!-- <i class="pi pi-car my-6 !text-[120px]"></i> -->
            <div class="h-full w-full p-4">
              <img src="assets/images/vehicle_fallback.png" alt="Vehicle Placeholder" class="h-full w-full object-contain opacity-30" />
            </div>
          }
        </div>
        <h2 class="mb-3 mt-6 max-w-full truncate whitespace-normal">
          {{ vehicle()?.name }}
        </h2>
        <p class="m-0 leading-relaxed">
          <span class="font-bold">{{ 'vehiclesDetails.label.modelYear' | transloco }}</span>
          {{ vehicle()?.madeFrom | date: 'yyyy' }} -
          {{ vehicle()?.madeUntil | date: 'yyyy' }}
        </p>
        <p class="m-0 leading-relaxed">
          <span class="font-bold">{{ 'vehiclesDetails.label.fuelType' | transloco }}</span>
          {{ fuelTypesString() }}
        </p>

        <p class="m-0 leading-relaxed">
          <span class="font-bold">{{ 'vehiclesDetails.label.power' | transloco }}</span>
          {{ vehicle()?.output }} kW
        </p>
        <p class="m-0 leading-relaxed">
          <span class="font-bold">{{ 'vehiclesDetails.label.capacity' | transloco }}</span>
          {{ vehicle()?.capacity }} ccm
        </p>

        <p class="m-0 leading-relaxed">
          <span class="font-bold">{{ 'vehiclesDetails.label.motorCode' | transloco }}</span>
          <span>{{ vehicle()?.engineCode }}</span>
        </p>

        @if (vehicle()?.vehicleIdentification?.vin) {
          <p class="mt-1">
            <span class="font-bold">{{ 'vehiclesDetails.label.vin' | transloco }}</span>
            {{ vehicle()?.vehicleIdentification?.vin }}
          </p>
        }

        @if (vehicle()?.vehicleIdentification?.kba) {
          <p class="mt-1">
            <span class="font-bold">{{ 'vehiclesDetails.label.kba' | transloco }}</span>
            {{ vehicle()?.vehicleIdentification?.kba }}
          </p>
        }
      </div>
    </div>
  </div>
}
